/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type b2b_v1_advisor_settings_CalculationsSettings = {
    base_currency?: b2b_v1_advisor_settings_CalculationsSettings.base_currency;
};
export namespace b2b_v1_advisor_settings_CalculationsSettings {
    export enum base_currency {
        USD = 'USD',
        EUR = 'EUR',
        SEK = 'SEK',
        BRL = 'BRL',
        GBP = 'GBP',
        GBX = 'GBX',
    }
}

